import axios from "axios";
import Swal from "sweetalert2";
import {
  TEACHING_PROCESS_LOADING,
  ADD_TEACHING_TASK_LIST,
  ADD_TEACHING_TASK_LIST_FAILED,
  GET_TEACHING_TASK_LIST,
  UPDATE_TEACHING_TASK_LIST,
  DELETE_TEACHING_TASK_LIST,
  DELETE_TEACHING_TASK_LIST_FAILED,
  GET_TEACHING_TASK_LIST_DETAIL,
  GET_TEACHING_DETAILS
} from ".";
import { serverUrl, apiUrl } from "../../components/Helpers/Config";
import { tokenAuthorize } from "../../components/Helpers/Common";

export const createTeachingTask = (groupId, title, dueDate, desc, task) => {

  return (dispatch) => {
    dispatch({ type: TEACHING_PROCESS_LOADING });

    return axios
      .post(serverUrl.Teaching, {
        group_id: groupId,
        list_name: title,
        list_due: dueDate,
        list_desc: desc,
        tasks: task,
      })
      .then((resp) => {
        if (resp.status === 200) {
          dispatch({ type: ADD_TEACHING_TASK_LIST, payload: { id: resp.data.id } });
        } else {
          dispatch({ type: ADD_TEACHING_TASK_LIST_FAILED });
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status)
        console.log(error);
        dispatch({ type: ADD_TEACHING_TASK_LIST_FAILED });
      });
  };
};

export const updateTeachingTask = (id, title, dueDate, desc, task) => {
  return (dispatch) => {
    return axios
      .put(serverUrl.Teaching + `/${id}`, {
        list_name: title,
        list_due: dueDate,
        list_desc: desc,
        tasks: task,
      })
      .then(() => {
        dispatch({ type: UPDATE_TEACHING_TASK_LIST });
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status)
        console.log(error);
      });
  };
};

export const getTeachingTask = () => {
  return (dispatch) => {
    return axios
      .get(serverUrl.Teaching)
      .then((response) => {
        dispatch({
          type: GET_TEACHING_TASK_LIST,
          payload: response.data,
        });
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status)
        console.log(error);
      });
  };
};

export const getTeachingTaskDetail = (id) => {
  return (dispatch) => {
    return axios
      .get(serverUrl.Teaching + `/${id}`)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch({
            type: GET_TEACHING_TASK_LIST_DETAIL,
            payload: resp.data,
          });
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status)
        console.log(error);
      });
  };
};

export const deleteTeachingTask = (id) => {
  return (dispatch) => {
    return axios
      .delete(serverUrl.Teaching + `/${id}`)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch({ type: DELETE_TEACHING_TASK_LIST });
        } else {
          dispatch({ type: DELETE_TEACHING_TASK_LIST_FAILED });
        }

        dispatch(getTeachingTask());
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status)
        console.log(error);
      });
  };
};


export const downloadstudentdetail = (id) => {
  return (dispatch) => {
    return axios
      .get(serverUrl.TeachingDownload + `/${id}`, { responseType: 'arraybuffer' })
      .then((resp) => {
        if (resp.status === 200) {
          var blob = new Blob([resp.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          var fileName = "StudentList.xlsx";
          link.download = fileName;
          link.click();
        } else {
          Swal.fire({
            title: "Info",
            text: "No data Found",
            icon: "info",
          })
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status)
        console.log(error);
        Swal.fire({
          title: "Error",
          text: "No data Found",
          icon: "error",
        })
      });
  };
};

export const downloadsubmissions = (id, paramid) => {
  return (dispatch) => {
    return axios
      .post(serverUrl.TeachingDownloadZip + "/" + paramid, { user_id: id }, { responseType: 'arraybuffer' })
      .then((resp) => {
        if (resp.status === 200) {
          var blob = new Blob([resp.data], { type: "application/zip" });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          var fileName = "Submissions.zip";
          link.download = fileName;
          link.click();
        } else {
          Swal.fire({
            title: "Info",
            text: "No data Found",
            icon: "info",
          })
        }
      })
      .catch((error) => {
        tokenAuthorize(error?.response?.status)
        console.log(error);
        Swal.fire({
          title: "Error",
          text: "No data Found",
          icon: "error",
        })
      });
  };
};

export const getTeachingView = (id) => {
  debugger
  return (dispatch) => {
    dispatch({
      type: GET_TEACHING_DETAILS,
      payload: id,
    });
  };
};
